// @flow

import { isProduction } from '@zapier/common-utils';

import level from '../level';

import type { Alert, HandleAlert } from './types';

type UnregisterHandler = () => void;

// Default alert handler
const defaultHandler = (theAlert: Alert) => {
  const cleanedMessage =
    theAlert &&
    theAlert.message
      .split('\n')
      .map(line => line.trim())
      .filter(line => line.length)
      .join('\n');
  console.error(`🚨${cleanedMessage}`, theAlert && theAlert.stack);
};

let theHandler = null;

// Decouple reporting from presentation
export default {
  //This is side-effecting. I'm sorry.
  alert(theAlert: Alert) {
    if (isProduction() || level.severity !== 'fatal') {
      return;
    }

    setTimeout(() => {
      defaultHandler(theAlert);

      if (theHandler) {
        theHandler(theAlert);
      }
    }, 0);
  },

  registerHandler(handler: HandleAlert): UnregisterHandler {
    theHandler = handler;

    return () => {
      theHandler = null;
    };
  },

  unregisterHandler(handler: HandleAlert) {
    if (theHandler === handler) {
      theHandler = null;
    }
  },
};
